// GET_LIMITED_ALL_LEAVE
export const GET_ALL_LEAVE_REQUEST = "GET_LIMITED_ALL_LEAVE_REQUEST";
export const GET_ALL_LEAVE_SUCCESS = "GET_LIMITED_ALL_LEAVE_SUCCESS";
export const GET_ALL_LEAVE_FAIL = "GET_ALL_LEAVE_FAIL";
